import { ActionReducerMap } from '@ngrx/store';
import {
  AuthenticationState,
  authenticationReducer,
} from './Authentication/authentication.reducer';
import { LayoutState, layoutReducer } from './layouts/layout-reducers';
import { NwmlsReducer, NwmlsState } from './nwmls/nwmls.reducer';
import { BlogsReducer, BlogsState } from './Blogs/blogs.reducer';
import { LeadsReducer, LeadsState } from './Leads/leads.reducer';
import {
  SubscribersReducer,
  SubscribersState,
} from './subscribers/subscribers.reducer';
import { UsersReducer, UsersState } from './users/users.reducer';
import { AgentsReducer, AgentsState } from './agents/agents.reducer';
import { Aris360Reducer, Aris360State } from './aris360/aris360.reducer';
import {
  SupportTicketsReducer,
  SupportTicketsState,
} from './support-tickets/support-tickets.reducer';
import {
  DashboardReducer,
  DashboardState,
} from './dashboards/dashboard.reducer';
import {
  AgentsRequestsReducer,
  AgentsRequestsState,
} from './agents-requests/agents-requests.reducer';
import { chatReducer, ChatState } from './chats/chats.reducer';
import {
  OffMarketPropertiesReducer,
  OffMarketPropertiesState,
} from './off-market-properties/off-market-properties.reducer';
import {
  ContactQueriesReducer,
  ContactQueriesState,
} from './contact-queries/contact-queries.reducer';
import {
  MarketedPropertiesReducer,
  MarketedPropertiesState,
} from './marketed-properties/marketed-properties.reducer';

export interface RootReducerState {
  layout: LayoutState;
  auth: AuthenticationState;
  nwmls: NwmlsState;
  blogs: BlogsState;
  leads: LeadsState;
  subscribers: SubscribersState;
  users: UsersState;
  agents: AgentsState;
  aris360: Aris360State;
  supportTickets: SupportTicketsState;
  dashboard: DashboardState;
  agentsRequests: AgentsRequestsState;
  chats: ChatState;
  offMarketProperties: OffMarketPropertiesState;
  contactQueries: ContactQueriesState;
  marketedProperties: MarketedPropertiesState;
}

export const rootReducer: ActionReducerMap<RootReducerState> = {
  layout: layoutReducer,
  auth: authenticationReducer,
  nwmls: NwmlsReducer,
  blogs: BlogsReducer,
  leads: LeadsReducer,
  subscribers: SubscribersReducer,
  users: UsersReducer,
  agents: AgentsReducer,
  aris360: Aris360Reducer,
  supportTickets: SupportTicketsReducer,
  dashboard: DashboardReducer,
  agentsRequests: AgentsRequestsReducer,
  chats: chatReducer,
  offMarketProperties: OffMarketPropertiesReducer,
  contactQueries: ContactQueriesReducer,
  marketedProperties: MarketedPropertiesReducer,
};
